import HttpService from '@/common/services/HttpService'
import type { SpaceDTOV1 } from '@/common/types/spaces'
import localizationServerData from '@/common/services/serverData/localizationServerData'
import { PrefixTranslationsEnum } from '@/common/types/i18n'
import { get as getCachedData } from '@/common/services/LocalStorageService'

const serviceRoot = '/api/v1/spaces'

/**
 * @deprecated
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchSpacesOld = async (): Promise<any> => {
  return await Promise.all([
    HttpService.getData<SpaceDTOV1[]>(serviceRoot),
    localizationServerData.fetch({
      prefixes: PrefixTranslationsEnum.SPACE,
    }),
  ])
}

export const getSpaces = async (cacheKey: string): Promise<SpaceDTOV1[]> => {
  return getCachedData<SpaceDTOV1[]>(cacheKey, serviceRoot)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchSpaces = async (cacheKey: string): Promise<any> => {
  return await Promise.all([
    getSpaces(cacheKey),
    localizationServerData.fetch({
      prefixes: PrefixTranslationsEnum.SPACE,
    }),
  ])
}
